export const productState = {
    loading : false,
    error : '',
    products : [],
    product : null
}